<template>
  <transition name="fade">
    <div class="vui-spin">
      <div class="vui-spin-dot"></div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'VuiSpin',
}
</script>

<style lang="scss">
.vui-spin {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 20;
  background-color: rgba(255, 255, 255, 0.9);

  .vui-spin-dot {
    width: 20px;
    height: 20px;
    margin-top: -10px;
    margin-left: -10px;
    border-radius: 50%;
    background-color: #2d8cf0;
    position: absolute;
    top: 50%;
    left: 50%;
    animation: ani-spin-bounce 1s 0s ease-in-out infinite;
  }
}

@keyframes ani-spin-bounce {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
    opacity: 0;
  }
}
</style>
